import React from 'react';

import ActionButton from '../../elements/ActionButton';

import AffiliatesList from './AffiliatesList';

import { PERMISSION } from 'crm/helpers/Permissions';

function AffiliatePage() {
    return (
        <>
            <ActionButton title="Create new affiliate" url="/affiliates/create" permissions={[PERMISSION.CREATE_AFFILIATE]} />
            <AffiliatesList />
        </>
    );
}

export default AffiliatePage;
